import { render } from "./AdminDataVertraege.vue?vue&type=template&id=e00a8996&scoped=true"
import script from "./AdminDataVertraege.vue?vue&type=script&lang=js"
export * from "./AdminDataVertraege.vue?vue&type=script&lang=js"

import "./AdminDataVertraege.vue?vue&type=style&index=0&id=e00a8996&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00a8996"]])

export default __exports__